<template>
  <div class="list__action__item--content">
    <div class="flex-row flex__between">
      <p class="name margin-0">
        {{ action.creatorName }}
      </p>
      <div class="time font-size__small">
        <i class="fal fa-clock">
          {{ action.createTime | convertToLabelFilter }}
        </i>
      </div>
    </div>
    <div>
      <p
        :class="['action-type flex-row flex__left inline-flex', 'color__blue']"
      >
        <i :class="['font-size__small', 'fal fa-check-circle']"></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ "Sửa sai văn bản đến" }}
        </span>
      </p>
      <popover-word2 v-for="(word, $index) in words" :key="$index" :word="word">
        <template v-slot:default="options">
          <el-table
            :data="valueChangeLogs"
            style="width: 100%"
            stripe
            max-height="400"
            :show-header="false"
            size="mini"
          >
            <el-table-column
              label="Thuộc tính "
              width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="padding-0 margin-0">
                  <span class="font-weight__bold font-size__small">
                    {{
                     getDisplayProperty(scope.row.properties)
                    }}

                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Thuộc tính "
              width="30"
              show-overflow-tooltip
            >
              <template slot-scope="scope">

                  <span class="font-size__small">
                    Từ:
                  </span>

              </template>
            </el-table-column>
            <el-table-column
              label="Giá trị cũ"
              width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="padding-0 margin-0">
                  <span class="font-weight__bold font-size__small">
                    {{
                      getDisplayValue(scope.row.properties, scope.row.oldValue)
                    }}
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Thuộc tính "
              width="40"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                  <span class=" font-size__small">
                    Đến:
                  </span>

              </template>
            </el-table-column>
            <el-table-column
              label="Giá trị mới"
              width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="padding-0 margin-0">
                  <span class="font-weight__bold font-size__small">
                    {{
                      getDisplayValue(scope.row.properties, scope.row.newValue)
                    }}
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </popover-word2>
    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import h from "../../services/h";
  import PopoverWord2 from "../common/popover-word-2";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";

  export default {
    name: "history-vbden-update",
    components: {PopoverWord2},
    props: ["action"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {
        words: ["Xem thay đổi"],
        valueChangeLogs: [],
        displayProperties: [
          "docCode",
          "docDate",
          "docTypeName",
          "priorityName",
          "numberOfPage",
          "numberOfCopy",
          "quote",
          "deadlineDate",
          "publisherName",
          "outsidePublisherName"
        ]
      };
    },
    created() {
      this.initData();
    },
    methods: {
      initData() {
        let dataJson = this.action.dataJson;
        //loai bo thay doi cua cac truong id (thay = hien thi name)
        this.valueChangeLogs = h.findAll(
          dataJson.valueChangeLogs,
          item => this.displayProperties.indexOf(item.properties) !== -1
        );
      },
      getDisplayProperty(property) {
        switch (property) {
          case "docCode":
            return "Số kí hiệu"
          case "docDate":
            return "Ngày văn bản";
          case "docTypeName":
            return "Loại văn bản"
          case "priorityName":
            return "Độ khẩn"
          case "numberOfPage":
            return "Số trang"
          case "numberOfCopy":
            return "Số bản"
          case "quote":
            return "Trích yếu"
          case "deadlineDate":
            return "Hạn xử lý"
          case "publisherName":
            return "Đơn vị bên trong"
          case "outsidePublisherName":
            return "Đơn vị bên ngoài"
          default:
            return "-"
        }
      },

      getDisplayValue(property, value) {
        switch (property) {
          case "docDate":
            return dateFormatter(value, {
              nullValue: "-",
              dateFormat: constants.DEFAULT_DATE_FORMAT
            });
          case "deadlineDate":
            return dateFormatter(value, {
              nullValue: "-",
              dateFormat: constants.DEFAULT_DATETIME_FORMAT
            });
          default:
            return value || "-";
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/history-vbden-update.vue